/**
 * Espera `ms` milissegundos, e desiste na hora se o `signal` abortar.
 *
 * O `signal` é o ponto: uma espera entre reperguntas que ignora o abort mantém viva a cadeia de
 * polling de quem já saiu da tela, e ela segue fazendo requisições — e salvando arquivo — depois
 * do fim (review do PR #1160, COR-01). Rejeita com `AbortError`, a mesma forma do `fetch`, para
 * o chamador tratar os dois cancelamentos por um caminho só.
 *
 * @example
 * await esperar(2_000, thunkAPI.signal);
 */
export const esperar = (ms: number, signal?: AbortSignal): Promise<void> =>
  new Promise((resolve, reject) => {
    if (signal?.aborted) {
      reject(new DOMException('Espera cancelada', 'AbortError'));
      return;
    }
    const timer = setTimeout(() => {
      signal?.removeEventListener('abort', cancelar);
      resolve();
    }, ms);
    function cancelar() {
      clearTimeout(timer);
      reject(new DOMException('Espera cancelada', 'AbortError'));
    }
    signal?.addEventListener('abort', cancelar, { once: true });
  });
